export const BASE_URL = "https://notesapp-backend-x5y2.onrender.com"